import React from "react";

const SunTimeline = ({ sunrise, sunset, currentTime }) => {
  const formatTime = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getDaylightProgress = () => {
    const now = new Date().getTime() / 1000;
    const dayStart = sunrise;
    const dayEnd = sunset;
    const dayLength = dayEnd - dayStart;
    const currentProgress = (now - dayStart) / dayLength;
    return Math.max(0, Math.min(1, currentProgress)) * 100;
  };

  const getSunPosition = () => {
    const progress = getDaylightProgress();
    if (progress <= 0) return "Night";
    if (progress >= 100) return "Night";
    if (progress < 25) return "Morning";
    if (progress < 75) return "Day";
    return "Evening";
  };

  const sunPosition = getSunPosition();
  const daylightProgress = getDaylightProgress();

  return (
    <div>
      <div className="relative h-32 mb-4">
        {/* Sky gradient background */}
        <div className="absolute inset-0 rounded-lg overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-blue-900 via-blue-400 to-orange-400" />
        </div>

        {/* Sun position indicator */}
        <div
          className="absolute top-1/2 -translate-y-1/2 w-8 h-8 bg-yellow-400 rounded-full shadow-lg"
          style={{
            left: `${daylightProgress}%`,
            transform: `translate(-50%, -50%)`,
          }}
        />

        {/* Timeline markers */}
        <div className="absolute bottom-0 left-0 right-0 flex justify-between px-2">
          <div className="text-white text-sm">{formatTime(sunrise)}</div>
          <div className="text-white text-sm">{formatTime(sunset)}</div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 text-center">
        <div>
          <div className="text-sm text-gray-600">Sunrise</div>
          <div className="font-medium">{formatTime(sunrise)}</div>
        </div>
        <div>
          <div className="text-sm text-gray-600">Current</div>
          <div className="font-medium">{sunPosition}</div>
        </div>
        <div>
          <div className="text-sm text-gray-600">Sunset</div>
          <div className="font-medium">{formatTime(sunset)}</div>
        </div>
      </div>

      <div className="mt-4 text-sm text-gray-600">
        {sunPosition === "Night" && "The sun is below the horizon."}
        {sunPosition === "Morning" && "The sun is rising in the sky."}
        {sunPosition === "Day" && "The sun is high in the sky."}
        {sunPosition === "Evening" && "The sun is setting in the sky."}
      </div>
    </div>
  );
};

export default SunTimeline;
